import { render, staticRenderFns } from "./List.vue?vue&type=template&id=be909386&scoped=true"
import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=be909386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be909386",
  null
  
)

export default component.exports